$(document).ready(function(){
    $('.tree-nation_line_btn').click(function(){
        $(".product-charity-outer_whole").show();
        $("body").addClass("popup-open");
        $(".product-charity-comparison_outer").css("display", "flex");
        var winHeight = $(window).height();
        if (winHeight > 1000){
          if ($(window).width() > 678) {
            var popupHeight = $(
              ".product-charity-comparison_popup"
            ).outerHeight();
            $(".product-charity-popup_close").css(
              "top",
              "calc(50% - " + popupHeight / 2 + "px + 16px)"
            );
            $('.product-charity-comparison_outer').css('align-items', 'center');
          }
        }
        else{
          $('.product-charity-comparison_outer').css('align-items', 'flex-start');
          $(".product-charity-popup_close").css(
            "top",
            "72px"
          );
        }
      });

      $(".product-charity-popup_close").click(function (evt) {
        evt.preventDefault();
        $(".product-charity-outer_whole").hide();
        $("body").removeClass("popup-open");
      });

      $('.certificates_scroll-area-outer').each(function () {
        var $outer = $(this);
        var $area = $outer.find('.certificates_scroll-area');
        var $prev = $outer.find('.certificates_scroll-arrow-prev');
        var $next = $outer.find('.certificates_scroll-arrow-next');
        var step = 300;
    
        function maxScroll() {
          var el = $area.get(0);
          return Math.max(0, el.scrollWidth - el.clientWidth);
        }
    
        function updateArrows() {
          var sl = $area.scrollLeft();
          var m = maxScroll();
          if (sl <= 0) $prev.addClass('hided'); else $prev.removeClass('hided');
          if (sl >= m - 1) $next.addClass('hided'); else $next.removeClass('hided');
        }
    
        function scrollBy(dx) {
          var target = Math.max(0, Math.min(maxScroll(), $area.scrollLeft() + dx));
          $area.stop().animate({ scrollLeft: target }, 250, updateArrows);
        }
    
        $prev.on('click', function (e) { e.preventDefault(); scrollBy(-step); });
        $next.on('click', function (e) { e.preventDefault(); scrollBy(step); });
    
        var ticking = false;
        $area.on('scroll', function () {
          if (!ticking) {
            window.requestAnimationFrame(function () { updateArrows(); ticking = false; });
            ticking = true;
          }
        });
    
        $(window).on('resize', updateArrows);
        setTimeout(updateArrows, 0);
      });
});